

function Newsletter(props) {
  return 'Newsletter'
}
export default Newsletter;